import { Button, Radio } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { useForm } from 'react-hook-form';
import { IPanRejectionForm, IRejectionModal } from '../../interface';

const REJECTION_REASONS = ['Photograph mismatch', 'DOB mismatch', 'PAN mismatch', 'Name mismatch'];

const PanRejectionModal = (props: IRejectionModal) => {
  const { closeModal, handleRejection } = props;
  const { register, handleSubmit, watch, reset } = useForm<IPanRejectionForm>();

  const reason = watch('reason');

  const handleReject = (data: IPanRejectionForm) => {
    handleRejection(data.reason);
    handleCancel();
  };

  const handleCancel = () => {
    closeModal();
    reset();
  };

  return (
    <div className={styles.rejectionModal}>
      <div className={styles.rejectionReasons}>
        {REJECTION_REASONS.map(reason => (
          <div key={reason}>
            <Radio id={reason} label={reason} value={reason} {...register('reason')} />
          </div>
        ))}
      </div>
      <div className={styles.buttonContainer}>
        <Button onClick={handleCancel} name={'cancel_rejection'} variant={'secondary'}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit(handleReject)}
          name={'done_reject'}
          type={'submit'}
          variant={'primary'}
          disabled={!reason}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default PanRejectionModal;
